import * as React from 'react';
import { Component, CSSProperties, ReactNode } from 'react';
import * as classNames from 'classnames';

import { checkRTLByRegExp } from '../../../common/language';

if (process.env.BROWSER) {
  require('./index.less');
}

import {
  INewsItem,
} from './model';
import {
  NewsStyleType,
  INewsConfig,
} from './model/config';

import ItemCommon from './item-common';
import ItemCovers from './item-covers';

interface IComponentProps {
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
  newConfig?: INewsConfig;
  styleType: NewsStyleType;
  news: INewsItem;
}

interface IComponentState {}

export default class NewsItem extends Component<IComponentProps, IComponentState> {
  constructor(props) {
    super(props);
    this.state = {};
    [
      'getCustomizeItem',
      'handleNewsOnClick',
    ].forEach((actionName: string) => {
      this[actionName] = this[actionName].bind(this);
    });
  }

  public render(): ReactNode {
    if (this.props.news === undefined || this.props.news === null) { return null; }
    const classesWrapper: string = classNames(this.props.className);
    const domNewsItem: ReactNode = this.getCustomizeItem();
    return (
      <div className={classesWrapper} style={this.props.style}>
        { domNewsItem }
      </div>
    );
  }

  public getCustomizeItem(): ReactNode {
    const news: INewsItem = this.props.news;
    const styleType: NewsStyleType = this.props.styleType;
    let isRTL: boolean = false;
    let domNewsItem: ReactNode = null;
    const styleObj: CSSProperties = {
      direction: 'ltr',
    };
    if (checkRTLByRegExp(news.title)) {
      styleObj.direction = 'rtl';
      isRTL = true;
    }
    switch (styleType) {
      case NewsStyleType.BigPic:
        break;
      case NewsStyleType.Covers:
        domNewsItem = (
          <ItemCovers
            isRTL={isRTL}
            news={news}
            onClick={() => this.handleNewsOnClick()}
            style={styleObj}
          />
        );
        break;
      case NewsStyleType.Common:
      default:
        domNewsItem = (
          <ItemCommon
            isRTL={isRTL}
            news={news}
            onClick={() => this.handleNewsOnClick()}
            style={styleObj}
          />
        );
    }
    return domNewsItem;
  }

  public handleNewsOnClick(): void {
    if (this.props.onClick) {
      this.props.onClick();
    }
  }

}
